import React, { useEffect, useState } from 'react';
import Table from '../../../component/Table/Table';
import { axiosInstance as axios } from '../../../axios/axios';
import { useDispatch, useSelector } from 'react-redux';
import * as Action from '../../../store/actions';
import Icon from '../../../component/Icon';
import { useNavigate } from 'react-router-dom';
import * as actionCreators from '../../../store/actionCreators/index';
// import modifyUserRole from "../../../utils/modifyUserRole";
import TableActionButton from '../../../component/Table/TableActionButton/TableActionButton';

function Users() {
  // const [users, setUsers] = useState(null);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [totalPage, setTotalPage] = useState(1);
  const [userLimit, setUserLimit] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  // const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: Action.GET_USERS, payload: [] });
        const res = await axios.get(
          `/api/dashboard/users?page=${page}&limit=6`
        );
        setUserLimit(res.data.meta.per_page);
        setTotalPage(res.data.meta.total);
        dispatch({ type: Action.GET_USERS, payload: res.data.data });
      } catch (err) {
        console.log(err.message);
        dispatch({ type: Action.GET_USERS, payload: [] });
      }
    })();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const viewUser = () => {};

  const deleteUser = (data) => {
    dispatch(actionCreators.deleteUser(data.id, setLoading, state.auth.token));
  };

  let data;
  if (
    state.user.backend.usersList &&
    state.user.backend.usersList.length !== 0
  ) {
    data = state.user.backend.usersList.map((el) => {
      return [
        `# ${el.id}`,
        el.firstname,
        el.lastname,
        el.phone,
        el.address,
        el.email,
        el.role,
        <TableActionButton
          clickedView={() => viewUser()}
          clickedDelete={() => deleteUser(el)}
          display={['view', 'delete']}
        />,
      ];
    });
  }

  const tableHead = [
    'User id',
    'First Name',
    'Last Name',
    'Phone',
    'Address',
    'Email',
    'Role',
    'Action',
  ];

  return (
    <div>
      <h2 className='text-greySecondary mb-8 ml-12 font-[500] text-3xl'>
        User Management
      </h2>
      <Table
        tableHead={tableHead}
        tableData={data}
        page={page}
        setPage={setPage}
        totalPage={totalPage}
        productLimit={userLimit}
      />
    </div>
  );
}

export default Users;
